exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.custom-markdown tr {\n  border-top: 1px solid #c6cbd1;\n  background: #fff; }\n\ndiv.custom-markdown th,\ndiv.custom-markdown td {\n  padding: 6px 13px;\n  border: 1px solid #dfe2e5; }\n\ndiv.custom-markdown table tr:nth-child(2n) {\n  background: #f6f8fa; }\n", ""]);

// exports
